"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[426],{

/***/ 28853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Queue_Queue)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/dnd/DragLayer.tsx + 3 modules
var DragLayer = __webpack_require__(32911);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/compositions/Queue/components/MonthTitle/MonthTitle.tsx + 1 modules
var MonthTitle = __webpack_require__(77929);
// EXTERNAL MODULE: ./src/compositions/Queue/components/EmptyItemBase/EmptyItemBase.tsx + 5 modules
var EmptyItemBase = __webpack_require__(47110);
;// CONCATENATED MODULE: ./src/compositions/Queue/components/EmptyItem/EmptyItem.tsx



const EmptyItem = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyItemBase/* default */.Z, {
        className: "rounded bg-white shadow",
        ...props
    });
/* harmony default export */ const EmptyItem_EmptyItem = (EmptyItem);

// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./local_modules/dnd/DragElement.tsx
var DragElement = __webpack_require__(12724);
// EXTERNAL MODULE: ./local_modules/links/getLinkWithParams.ts
var getLinkWithParams = __webpack_require__(54780);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/modules/collaborations/useProductCollaborationLabel.ts + 1 modules
var useProductCollaborationLabel = __webpack_require__(52170);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(73358);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(10016);
// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(79230);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
// EXTERNAL MODULE: ./src/compositions/ProductUserRating/ProductUserRating.tsx
var ProductUserRating = __webpack_require__(28600);
// EXTERNAL MODULE: ./src/compositions/Queue/components/ItemLabel/ItemLabel.tsx + 1 modules
var ItemLabel = __webpack_require__(87824);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(65021);
// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(64895);
// EXTERNAL MODULE: ./local_modules/trap-focus/TrapFocus.ts
var TrapFocus = __webpack_require__(54490);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
;// CONCATENATED MODULE: ./src/compositions/Queue/components/ProductItem/components/DeleteConfirmation/messages.ts
/* harmony default export */ const DeleteConfirmation_messages = ({
    text: {
        en: "Are you sure you’d like to remove this<br />item from {month}?"
    },
    confirm: {
        en: "I’m sure"
    },
    cancel: {
        en: "Keep it"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/ProductItem/components/DeleteConfirmation/DeleteConfirmation.tsx








const DeleteConfirmation = (param)=>{
    let { month, onConfirm, onCancel } = param;
    const text = {
        ...DeleteConfirmation_messages.text,
        values: {
            month: date/* default */.ZP.months()[month - 1]
        }
    };
    const dialogId = (0,useUniqueId/* default */.Z)("deleteConfirmation");
    (0,react.useEffect)(()=>{
        const trapFocusElement = document.getElementById(dialogId);
        // could be "null" if modal opened in iframe
        if (trapFocusElement) {
            const trapFocus = new TrapFocus/* default */.Z(trapFocusElement, {
                withInitialFocus: false
            });
            trapFocusElement.focus();
            trapFocus.mount();
            return ()=>{
                trapFocus.unmount();
            };
        }
    }, [
        dialogId
    ]);
    const handleKeyUp = (param)=>{
        let { key } = param;
        if (key === "Escape" || key === "Esc") {
            onCancel();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: dialogId,
        className: "absolute inset-0 flex flex-col items-center justify-center bg-white p-16",
        tabIndex: 0,
        role: "dialog",
        "aria-modal": "true",
        "data-testid": "deleteConfirmation",
        onKeyUp: handleKeyUp,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: text,
                style: "p3",
                align: "center",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-20 flex items-center justify-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        title: DeleteConfirmation_messages.cancel,
                        style: "secondary",
                        size: 38,
                        width: 120,
                        "data-testid": "removeCancel",
                        onClick: onCancel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: "ml-12",
                        title: DeleteConfirmation_messages.confirm,
                        style: "primary",
                        size: 38,
                        width: 120,
                        "data-testid": "removeConfirm",
                        onClick: onConfirm
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const DeleteConfirmation_DeleteConfirmation = (DeleteConfirmation);

;// CONCATENATED MODULE: ./src/compositions/Queue/components/ProductItem/messages.ts
/* harmony default export */ const ProductItem_messages = ({
    itemAriaLabel: {
        en: "{brand} {name} movable queue item, press space to start moving"
    },
    removeAriaLabel: {
        en: "Remove {brand} {name} from the queue"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/ProductItem/ProductItem.tsx















const ProductItem = (props)=>{
    const { data, month, onItemDelete } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const intl = (0,useIntl/* default */.Z)();
    const { flatIndex, drift, tradingItem: { productInfo: { id, url, image, rebrandImage, rebrandLabels, name, fullName, brandInfo: { name: brand }, upchargePrice } }, stateOptions: { isUnavailable, isDelivered, isMovable, isFree } } = data;
    const { description: driftDescription, name: driftName, image: driftImage, scentOfMonthUid } = drift || {};
    const handleRef = (0,react.useRef)(null);
    const [isDeleteConfirmationVisible, setDeleteConfirmationVisibility] = (0,react.useState)(false);
    const collaborationLabel = (0,useProductCollaborationLabel/* default */.Z)({
        labels: rebrandLabels
    });
    const isCollaborationLabelVisible = Boolean(collaborationLabel) && !isDeleteConfirmationVisible;
    const nameLine = driftDescription || name;
    const brandLine = driftName || brand;
    const productUrl = scentOfMonthUid ? (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.driftSubscriptionPDP, {
        uid: scentOfMonthUid
    }) : url;
    const handleDeleteClick = ()=>{
        setDeleteConfirmationVisibility(true);
    };
    const handleCancelDeleteClick = ()=>{
        setDeleteConfirmationVisibility(false);
    };
    const handleConfirmDeleteClick = ()=>{
        setDeleteConfirmationVisibility(false);
        onItemDelete(flatIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DragElement/* default */.Z, {
        index: flatIndex,
        handle: handleRef,
        disabled: !isMovable || isDeleteConfirmationVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex items-start justify-start rounded bg-white shadow",
            role: "button",
            tabIndex: 0,
            "aria-label": intl.formatMessage(ProductItem_messages.itemAriaLabel, {
                brand: brandLine,
                name: nameLine
            }),
            "data-productid": id,
            "data-testid": "queueProduct",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                    to: productUrl,
                    className: "mx-8 my-16 block flex-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                        className: "w-[120rem]",
                        src: driftImage || rebrandImage || image
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "my-16 flex-1 self-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
                            to: productUrl,
                            "aria-label": `Get details about ${fullName}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    style: isMobile ? "h8" : "h7",
                                    color: "gold-50",
                                    message: brandLine,
                                    "data-testid": "itemBrandName"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    className: "mt-8",
                                    style: isMobile ? "p3" : "p2",
                                    message: nameLine,
                                    "data-testid": "itemProductName"
                                })
                            ]
                        }),
                        Boolean(isUnavailable || isFree || upchargePrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel/* default */.Z, {
                            className: "mt-8",
                            isFree: isFree,
                            isUnavailable: isUnavailable,
                            upchargePrice: upchargePrice
                        }),
                        isDelivered ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductUserRating/* default */.Z, {
                                productId: id,
                                flow: "Queue page",
                                shouldOpenReviewModalOnRate: true,
                                withHint: true
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                            className: "mt-16",
                            to: productUrl,
                            title: messages/* default */.Z.details
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative my-8 ml-16 mr-8 flex w-24 flex-none items-center self-stretch",
                    children: isMovable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "absolute right-0 top-0 cursor-pointer",
                                type: "button",
                                onClick: handleDeleteClick,
                                "aria-label": intl.formatMessage(ProductItem_messages.removeAriaLabel, {
                                    brand,
                                    name
                                }),
                                "data-testid": "queueProductRemove",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "24/close"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                ref: handleRef,
                                className: "cursor-move",
                                type: "button",
                                tabIndex: -1,
                                "data-testid": "queueProductMove",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "24/drag"
                                })
                            })
                        ]
                    })
                }),
                isDeleteConfirmationVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteConfirmation_DeleteConfirmation, {
                    month: month,
                    onConfirm: handleConfirmDeleteClick,
                    onCancel: handleCancelDeleteClick
                }),
                isCollaborationLabelVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                    className: "-left-6 top-8",
                    title: collaborationLabel,
                    bgColor: "black",
                    textColor: "gold-30",
                    absolute: true,
                    withTail: true
                })
            ]
        })
    });
};
/* harmony default export */ const ProductItem_ProductItem = (/*#__PURE__*/react.memo(ProductItem));

;// CONCATENATED MODULE: ./src/compositions/Queue/components/Month/messages.ts
/* harmony default export */ const Month_messages = ({
    skipped: {
        en: "You’ve skipped this month"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/Month/Month.tsx









const Month = (props)=>{
    const { data, isChanging, withTrendProductsModal, onItemDelete, onEmptyItemClick } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { month, products, tracking, stateOptions } = data;
    // to write FOM in the first
    let emptyItemsCount = 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthTitle/* default */.Z, {
                month: month,
                stateOptions: stateOptions,
                tracking: tracking
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8",
                children: stateOptions.isSkipped ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "rounded bg-white px-16 py-20 shadow",
                    style: isMobile ? "p3" : "p2",
                    align: "center",
                    message: Month_messages.skipped,
                    "data-testid": "queueMonthSkippedText"
                }) : products.map((item, index)=>{
                    let itemNode;
                    if (item.stateOptions.isEmpty) {
                        itemNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyItem_EmptyItem, {
                            isFOM: emptyItemsCount === 0,
                            isFree: item.stateOptions.isFree,
                            withTrendProductsModal: withTrendProductsModal,
                            onClick: onEmptyItemClick
                        });
                        emptyItemsCount++;
                    } else if (isChanging && !item.stateOptions.isBlocked) {
                        itemNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                            pw: 100,
                            h: 152
                        });
                    } else {
                        itemNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem_ProductItem, {
                            data: item,
                            month: month,
                            onItemDelete: onItemDelete
                        });
                    }
                    // TODO add lite plan item - added on 2021-06-11 by maddoger
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: index > 0 ? "pt-16" : null,
                        children: itemNode
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ const Month_Month = (/*#__PURE__*/react.memo(Month));

// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(83913);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./src/modules/queue/index.ts + 7 modules
var queue = __webpack_require__(11982);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
;// CONCATENATED MODULE: ./src/compositions/Queue/util/useQueueLogic.tsx








const useQueueLogic = ()=>{
    const { items, error } = (0,queue/* useQueue */.Ln)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const [moveItem, { isFetching: isMoveFetching }] = (0,queue/* useQueueMoveItem */.d_)();
    const [deleteItem, { isFetching: isDeleteFetching }] = (0,queue/* useQueueDeleteItem */.xi)();
    const shippingPeriod = (0,react.useRef)(null);
    shippingPeriod.current = subscription?.plan?.shippingPeriod;
    const handleDragEnd = (0,react.useCallback)(async (indexFrom, indexTo)=>{
        logger/* default */.Z.info("User moved queue item from %d to %d", indexFrom, indexTo);
        try {
            const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
            // we don't want to break browser because of the error during mutation
            const queueItems = await moveItem({
                indexFrom,
                indexTo,
                metadata: {
                    page,
                    pageType,
                    placement: "queue"
                }
            });
            const movedItem = (0,queue/* getProductFromQueueByFlatIndex */.Q_)(indexTo, queueItems);
            const closestMonthProducts = (0,queue/* getClosestAvailableMonth */.xE)(queueItems)?.products;
            if (movedItem?.tradingItem?.isLimitedEdition && closestMonthProducts) {
                const isMovedToClosestAvailableMonth = closestMonthProducts.some((param)=>{
                    let { flatIndex } = param;
                    return flatIndex === indexTo;
                });
                const isMovedFromClosestAvailableMonth = closestMonthProducts.some((param)=>{
                    let { flatIndex } = param;
                    return flatIndex === indexFrom;
                });
                const isLEPMovedBackward = isMovedFromClosestAvailableMonth && !isMovedToClosestAvailableMonth;
                const isPutFirstInQueueModalVisible = isLEPMovedBackward && shippingPeriod.current === 1 && !cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.isPutFirstInQueueModalShown);
                if (isPutFirstInQueueModalVisible) {
                    const updatedItem = (0,queue/* getProductFromQueueByFlatIndex */.Q_)(indexTo, queueItems);
                    (0,manager/* openModal */.h7)("putFirstToQueueModal", {
                        productIndex: updatedItem.flatIndex
                    });
                    cookie_storage/* default */.ZP.setSessionItem(constants/* default */.Z.cookieNames.isPutFirstInQueueModalShown, true);
                }
            }
        } catch (error) {
            (0,errors/* processError */.wY)(error);
        }
    }, [
        moveItem
    ]);
    const handleItemDelete = (0,react.useCallback)(async (index)=>{
        logger/* default */.Z.info("User deleted queue item from %d", index);
        try {
            const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
            // we don't want to break browser because of the error during mutation
            await deleteItem({
                index,
                metadata: {
                    page,
                    pageType,
                    placement: "queue"
                }
            });
        } catch (error) {
            (0,errors/* processError */.wY)(error);
        }
    }, [
        deleteItem
    ]);
    return {
        items,
        isChanging: isMoveFetching || isDeleteFetching,
        error,
        handleDragEnd,
        handleItemDelete
    };
};
/* harmony default export */ const util_useQueueLogic = (useQueueLogic);

;// CONCATENATED MODULE: ./src/compositions/Queue/Queue.tsx







const Queue = (props)=>{
    const { contentAfterSecondMonth, withTrendProductsModal, onEmptyItemClick } = props;
    const { items, isChanging, handleDragEnd, handleItemDelete } = util_useQueueLogic();
    if (!items) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            pw: 100,
            h: 200
        });
    }
    let lastYear;
    const nodes = items.map((item, index)=>{
        const { year } = item;
        const showYear = Boolean(lastYear && lastYear !== year);
        lastYear = year;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                index === 2 && contentAfterSecondMonth,
                showYear && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mb-16 mt-40",
                    style: "h7",
                    align: "center",
                    message: String(year)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: index > 0 ? "mt-24" : null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Month_Month, {
                        data: item,
                        isChanging: isChanging,
                        withTrendProductsModal: withTrendProductsModal,
                        onEmptyItemClick: onEmptyItemClick,
                        onItemDelete: handleItemDelete
                    })
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DragLayer/* default */.Z, {
        axis: "y",
        touchDelay: 150,
        mouseDelay: 250,
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            role: "group",
            children: nodes
        })
    });
};
/* harmony default export */ const Queue_Queue = (Queue);


/***/ }),

/***/ 47110:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ EmptyItemBase_EmptyItemBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./local_modules/modals/standaloneModal.tsx
var standaloneModal = __webpack_require__(8813);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/feedback/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(14830);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(80759);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(61420);
// EXTERNAL MODULE: ./src/helpers/primitives/array.ts
var array = __webpack_require__(95820);
;// CONCATENATED MODULE: ./src/compositions/Queue/components/TrendProductsModal/util/emptyProductRecommendations.graphql.ts
const EmptyProductRecommendationsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "EmptyProductRecommendations"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "recommendationsEmptyQueue"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "limit"
                                            },
                                            "value": {
                                                "kind": "IntValue",
                                                "value": "15"
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "metadata"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "page"
                                                        },
                                                        "value": {
                                                            "kind": "StringValue",
                                                            "value": "Queue",
                                                            "block": false
                                                        }
                                                    },
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "pageType"
                                                        },
                                                        "value": {
                                                            "kind": "StringValue",
                                                            "value": "Queue",
                                                            "block": false
                                                        }
                                                    },
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "placement"
                                                        },
                                                        "value": {
                                                            "kind": "StringValue",
                                                            "value": "empty queue recommendations modal",
                                                            "block": false
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "recommenderName"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "products"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "ProductBase"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "TradingItemBase"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "TradingItem"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "section"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productGroup"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "image"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "inStock"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isLimitedEdition"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "volume"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "unit"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "volume"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "prices"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "standardPrice"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "discountPrice"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amount"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "amountCents"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currencyCode"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ProductBase"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Product"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "url"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fullName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "type"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "brandInfo"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "image"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rebrandImage"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "gender"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "theEdit"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rebrandLabels"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "marketing"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "extra"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "characteristic"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "typeGroup"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "upchargePrice"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasLep"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasVariety"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isSubscribedToStockNotification"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "rating"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "avgRate"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "selectedTradingItem"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "tradingItems"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "items"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "TradingItemBase"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "shareEmailAgreement"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "exceptMobileBanner"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "banner"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "type"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "DESKTOP"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "kind": "Field",
                                    "alias": {
                                        "kind": "Name",
                                        "value": "mobileBanner"
                                    },
                                    "name": {
                                        "kind": "Name",
                                        "value": "banner"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "type"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "MOBILE"
                                            }
                                        }
                                    ]
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "title"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "advantages"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "agreement"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "note"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
EmptyProductRecommendationsDocument["definitions"] = [
    ...new Set(EmptyProductRecommendationsDocument.definitions)
];
/* harmony default export */ const emptyProductRecommendations_graphql = (EmptyProductRecommendationsDocument);

;// CONCATENATED MODULE: ./src/compositions/Queue/components/TrendProductsModal/util/index.ts





const useEmptyProductRecommendations = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { data, isFetching } = (0,useQuery/* default */.Z)(emptyProductRecommendations_graphql, {
        fetchPolicy: "cache-first"
    });
    return (0,react.useMemo)(()=>{
        let { products, recommenderName } = data?.recommendationsEmptyQueue?.data || {};
        if (products?.length) {
            products = array/* default */.Z.shuffle(products).slice(0, isMobile ? 4 : 3);
        }
        return {
            isFetching,
            recommenderName,
            products
        };
    }, [
        data,
        isFetching,
        isMobile
    ]);
};

;// CONCATENATED MODULE: ./src/compositions/Queue/components/TrendProductsModal/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Selected for you"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/TrendProductsModal/TrendProductsModal.tsx










const TrendProductsModal = (param)=>{
    let { name, closeModal } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { products, recommenderName, isFetching } = useEmptyProductRecommendations();
    let content;
    const areProductsExist = Boolean(products?.length);
    if (isFetching) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            className: "w-full",
            h: isMobile ? 332 : 324
        });
    } else if (areProductsExist) {
        const metadata = {
            placement: "Empty queue popup",
            recommenderName
        };
        const buttonProps = {
            metadata,
            onClick: ()=>closeModal()
        };
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx/* default */.Z)("grid grid-rows-1 gap-16", isMobile ? "grid-cols-2" : "grid-cols-3"),
            children: products.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmall/* default */.Z, {
                    className: "h-full w-full",
                    data: data,
                    buttonProps: buttonProps
                }, data.id))
        });
    }
    (0,react.useEffect)(()=>{
        if (!isFetching && !areProductsExist) {
            closeModal();
        }
    }, [
        closeModal,
        isFetching,
        areProductsExist
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: messages.title,
        closeModal: closeModal,
        "data-testid": name,
        children: content
    });
};
/* harmony default export */ const TrendProductsModal_TrendProductsModal = ((0,standaloneModal/* default */.Z)("trendProductsModal", TrendProductsModal));

// EXTERNAL MODULE: ./src/compositions/Queue/components/ItemLabel/ItemLabel.tsx + 1 modules
var ItemLabel = __webpack_require__(87824);
;// CONCATENATED MODULE: ./src/compositions/Queue/components/EmptyItemBase/messages.ts
/* harmony default export */ const EmptyItemBase_messages = ({
    title: {
        en: "Pick your next scent"
    },
    fomText: {
        en: "If this slot is empty, we’ll ship you our curated Fragrance of the Month."
    },
    surpriseText: {
        en: "Can’t find one? No problem, we’ll ship you a surprise fragrance!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/EmptyItemBase/EmptyItemBase.tsx










const EmptyItemBase = (props)=>{
    const { className, isFOM, isFree, withTrendProductsModal = true, onClick } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Empty queue click");
        if (withTrendProductsModal) {
            (0,manager/* openModal */.h7)("trendProductsModal");
        }
        if (typeof onClick === "function") {
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)(className, "flex cursor-pointer items-center justify-start"),
                role: "button",
                tabIndex: 0,
                onClick: handleClick,
                "data-testid": "queueEmptyProduct",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mx-8 my-16 flex-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                className: "size-[120rem]",
                                name: "other/product",
                                color: "black"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                className: "absolute right-8 top-32",
                                name: "40/plus-in-circle",
                                color: "gold-30"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mr-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                style: isMobile ? "h8" : "h7",
                                color: "gold-50",
                                message: EmptyItemBase_messages.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: "mt-8",
                                style: isMobile ? "p3" : "p2",
                                message: isFOM ? EmptyItemBase_messages.fomText : EmptyItemBase_messages.surpriseText
                            }),
                            isFree && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel/* default */.Z, {
                                className: "mt-8",
                                isFree: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendProductsModal_TrendProductsModal, {})
        ]
    });
};
/* harmony default export */ const EmptyItemBase_EmptyItemBase = (/*#__PURE__*/react.memo(EmptyItemBase));


/***/ }),

/***/ 87824:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ItemLabel_ItemLabel)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/components/dataDisplay/OfferLabel/OfferLabel.tsx
var OfferLabel = __webpack_require__(58354);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/feedback/Explanation/Explanation.tsx + 3 modules
var Explanation = __webpack_require__(95204);
;// CONCATENATED MODULE: ./src/compositions/Queue/components/ItemLabel/messages.ts
/* harmony default export */ const ItemLabel_messages = ({
    free: {
        label: {
            en: "Free"
        },
        explanation: {
            title: {
                en: "What is a gift?"
            },
            text: {
                en: `
          Lucky you! When you have a gift on your queue, that means the product has already been paid for,
          so you won’t be charged.
        `
            }
        }
    },
    upcharge: {
        label: {
            en: "Plus {price}"
        },
        explanation: {
            title: {
                en: "What is a premium product?"
            },
            text: {
                en: `
          Feeling fancy? Scentbird offers a limited run of super-luxe items.
          Premium products will cost an additional $5, $10, or $15 depending on the item, which you'll see reflected in
          your account should you choose to include one. <br /><br />
          When you opt for a premium product surcharge will be applied to all subscription types including referrals,
          gift cards, and limited-time offers.
        `
            }
        }
    },
    freeWithUpcharge: {
        label: {
            en: "Free + {price} for Premium"
        },
        explanation: {
            title: {
                en: "You received a gift, but we have to charge you for premium product"
            },
            text: {
                en: `
        Scentbird offers a limited run of super-luxe items in their full-sized form.
        Premium products will cost an additional $5, $10, or $15 depending on the item, which you'll see reflected in your account should you choose to include one.
        <br /><br />
        When you opt for a premium product, a surcharge will be applied to all subscription types including referrals, gift cards, and limited-time offers.
        `
            }
        }
    },
    outOfStock: {
        label: {
            en: "Out of stock"
        },
        explanation: {
            title: {
                en: "This product is out of stock"
            },
            text: {
                en: `
          We’re currently sold out of this product, but watch this space – we may be restocking
          this fragrance sometime in the very near future!
        `
            }
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/ItemLabel/ItemLabel.tsx










// to track only first event otherwise there will be too many of them
const eventTracked = {};
const getItemLabel = (param)=>{
    let { isFree, isUnavailable, upchargePrice } = param;
    if (isUnavailable) {
        return {
            data: ItemLabel_messages.outOfStock,
            labelTestId: "outOfStockLabel",
            type: "Out of stock"
        };
    }
    const price = (0,formatPrice/* default */.Z)(upchargePrice, {
        removeZeroCents: true
    });
    if (isFree && upchargePrice) {
        return {
            data: {
                explanation: ItemLabel_messages.freeWithUpcharge.explanation,
                label: {
                    ...ItemLabel_messages.freeWithUpcharge.label,
                    values: {
                        price
                    }
                }
            },
            labelTestId: "freePlusPremiumLabel",
            type: "Free + Premium"
        };
    }
    if (isFree) {
        return {
            data: ItemLabel_messages.free,
            labelTestId: "freeLabel",
            type: "Free"
        };
    }
    if (upchargePrice) {
        return {
            data: {
                explanation: ItemLabel_messages.upcharge.explanation,
                label: {
                    ...ItemLabel_messages.upcharge.label,
                    values: {
                        price
                    }
                }
            },
            labelTestId: "premiumLabel",
            type: "Premium"
        };
    }
    return {
        data: null,
        labelTestId: null,
        type: null
    };
};
const ItemLabel = (props)=>{
    const { className, isUnavailable, isFree, upchargePrice } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const withMultiLineLabel = isMobile && isFree && upchargePrice;
    const { data, labelTestId, type } = (0,react.useMemo)(()=>{
        return getItemLabel({
            isFree,
            isUnavailable,
            upchargePrice
        });
    }, [
        isFree,
        isUnavailable,
        upchargePrice
    ]);
    const handleShow = (0,react.useCallback)(()=>{
        if (!eventTracked[type]) {
            (0,analytics/* track */.j)("Product badge info display", {
                type
            });
            eventTracked[type] = true;
        }
    }, [
        type
    ]);
    if (!data) {
        return null;
    }
    const containerClassName = (0,clsx/* default */.Z)(className, "flex", withMultiLineLabel ? "flex-col items-start justify-center" : "items-center justify-start");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: containerClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferLabel/* default */.Z, {
                title: data.label,
                "data-testid": labelTestId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Explanation/* default */.Z, {
                title: data.explanation.title,
                text: data.explanation.text,
                onShow: handleShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: (0,clsx/* default */.Z)("py-4 underline", withMultiLineLabel ? "mt-4" : "ml-8"),
                    message: messages/* default */.Z.whatsThis,
                    style: "p5",
                    html: true
                })
            })
        ]
    });
};
/* harmony default export */ const ItemLabel_ItemLabel = (/*#__PURE__*/react.memo(ItemLabel));


/***/ }),

/***/ 77929:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ MonthTitle_MonthTitle)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(64895);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(79230);
;// CONCATENATED MODULE: ./src/compositions/Queue/components/MonthTitle/messages.ts
/* harmony default export */ const messages = ({
    changeBy: {
        // TODO "by the 3rd" - isn't actual with 4-wave billing - added on 31.08.2021 by sonatskiy
        en: "Make a change to your {monthName} delivery by the 3rd."
    },
    processing: {
        en: "Your {monthName} delivery is being prepped."
    },
    shipped: {
        en: "Your {monthName} order has shipped!"
    },
    delivered: {
        en: "Your {monthName} order has been delivered! Rate your product now."
    },
    track: {
        en: "Track it"
    }
});

;// CONCATENATED MODULE: ./src/compositions/Queue/components/MonthTitle/MonthTitle.tsx







const MonthTitle = (props)=>{
    const { month, tracking, stateOptions } = props;
    const title = (0,react.useMemo)(()=>{
        const monthName = date/* default */.ZP.months()[month - 1];
        if (stateOptions.isDelivered) {
            return {
                ...messages.delivered,
                values: {
                    monthName
                }
            };
        }
        if (stateOptions.isShipped) {
            return {
                ...messages.shipped,
                values: {
                    monthName
                }
            };
        }
        if (stateOptions.isLocked) {
            return {
                ...messages.processing,
                values: {
                    monthName
                }
            };
        }
        return monthName;
    }, [
        month,
        stateOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between",
        "data-testid": "queueMonthTitle",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "p2",
                message: title,
                "data-testid": "queueMonthTitleMessage"
            }),
            Boolean(tracking?.url && !stateOptions.isDelivered) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                style: "gold-50",
                toTab: tracking.url,
                title: messages.track,
                onClick: ()=>{
                    (0,analytics/* track */.j)("Delivery tracking click", {});
                },
                "data-testid": "queueMonthTitleTracking"
            })
        ]
    });
};
/* harmony default export */ const MonthTitle_MonthTitle = (MonthTitle);


/***/ })

}]);